import { debounce, ceil, reduce, isEmpty, trim, sortBy as sort, indexOf, isArray } from 'lodash';
import React, { useState, useEffect, useMemo, useRef, Children } from 'react';
import { Col, Row, Tooltip, Spin, message, Popover, Upload, notification, Popconfirm } from 'antd';
import { IoCloudUploadOutline } from 'react-icons/io5';
import { AiOutlineDelete } from 'react-icons/ai';
import { useNavigate, useNavigation } from 'react-router-dom';
import XLSX from 'xlsx';
import * as Switch from '@radix-ui/react-switch';



import SearchInput from '../../components/uiComponent/inputs/searchinput/index';
import Select from '../../components/uiComponent/select/index';
import Button from '../../components/uiComponent/button/index';
import AgGrid from '../../components/ag-grid-table/index';
import Pagination from '../../components/pagination/index';
import SkuRowDetails from './skuRowDetails';
import AddSkuModal from './AddSkuModal';
import Modal from "../../components/uiComponent/modal/index";

import iconPurple from '../../assets/images/box-icon-purple.svg';
import iconBlue from '../../assets/images/box-icon-blue.svg';
import iconRed from '../../assets/images/box-icon-red.svg';
import iconYellow from '../../assets/images/box-icon-yellow.svg';
import iconGreen from '../../assets/images/box-icon-green.svg';
import iconOrange from '../../assets/images/box-icon-orange.svg';
import ProductImg from '../../assets/images/newImages/nestle.svg';
import copyIcon from '../../assets/images/newImages/copy-white-icon.svg';
import copyIcona from '../../assets/images/newImages/copyIcona.svg';
import { GoUpload } from 'react-icons/go';
import { IoIosArrowDown } from 'react-icons/io';



import copyYellowIcon from '../../assets/images/newImages/copy-yellow-icon.svg';
import AmazonLogo from '../../assets/images/newImages/amazon-short-logo.svg';
import InfoIcon from '../../assets/images/newImages/info-icon-blue.svg';
import uploadIcon from '../../assets/images/newImages/upload-icon.svg';
import importIcon from '../../assets/images/newImages/import-xlsx.svg';
import WarningInfoIcon from '../../assets/images/newImages/info-icon.svg';
import FileIcon from '../../assets/icons/file-icon.svg';

import InventoryWrapper from './style';


import { GetSKUs, GetStats, CheckWorkOrderLinkStatus, UpdateVarietyPack, GetSkuUnitCostHistories, ExportSkuMapping, ExportFilteredSKUs } from '../../slices/3-layer-products';
import { GetVendorsList } from '../../slices/po';
import { useSelector, useDispatch } from 'react-redux';

import { FULFILLMENT_TYPES, SKU_STATUSES, OPEN_PRODUCT_TO_AMAZON_URL } from '../../constants/threeLayer';
import { GetPresignedUrl, StoreProductsFile } from '../../slices/aws-services';
import { CreateWorkOrder } from '../../slices/work-orders';
import MapProductModal from './MapProductModal';
import { copyToClip } from '../../utils/utils';
import { HeaderRowComp } from 'ag-grid-community';
import MappingAlert from './mappingAlert';
import { setItem } from '../../slices/auth';

const { Dragger } = Upload;


const defaultColDef = {
  resizable: true,
  sortable: false,
  suppressMenu: true,
  suppressMovable: true,
  suppressSorting: true
};

let gridApi;
let gridColumnApi;

const CogsCellRenderer = (params) => {
  const { value, data, context } = params;
  if (value == null || value === '' || value === 0) return '-';
  const num = Number(value);
  const formattedValue = Number.isInteger(num) ? num.toString() : num.toFixed(2);

  return (
    <div className='d-flex align-items-center gap-1'>
      <span>{formattedValue}</span>
      <img
        src={InfoIcon}
        alt='info'
        className='cursor-pointer'
        width={14}
        height={14}
        onClick={() => context?.openCogsModal(data?.id)}
      />
    </div>
  );
};

const VarietyPackSwitch = ({ data }) => {
  const dispatch = useDispatch();
  const isChecked = !!data?.is_variety_pack;
  const isDisabled = data?.is_variety_pack && data?.products_v2?.length > 1;


  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <Tooltip title={isDisabled ? 'Toggle cannot be changed for variety packs. Please unlink products first' : null}>
        <span>
          <Popconfirm
            title={isChecked ? 'Unmark this SKU as a Variety Pack?' : 'Mark this SKU as a Variety Pack?'}
            okText="Yes"
            cancelText="No"
            placement="top"
            disabled={isDisabled}
            onConfirm={() => {
              dispatch(UpdateVarietyPack({
                skuId: data?.id,
                newVarietyPackStatus: !isChecked
              }));
            }}
          >
            <span>
              <Switch.Root
                checked={isChecked}
                disabled={isDisabled}
                onClick={(e) => e.preventDefault()}
                style={{
                  width: '42px',
                  height: '25px',
                  backgroundColor: isChecked ? '#1565D8' : '#E9ECEF',
                  borderRadius: '9999px',
                  position: 'relative',
                  border: 'none',
                  padding: '0',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  opacity: isDisabled ? 0.5 : 1,
                  transition: 'background-color 0.2s, opacity 0.2s'
                }}
              >
                <Switch.Thumb
                  style={{
                    display: 'block',
                    width: '21px',
                    height: '21px',
                    backgroundColor: 'white',
                    borderRadius: '9999px',
                    boxShadow: '0 2px 4px 0 rgba(0, 35, 11, 0.2)',
                    transform: isChecked ? 'translateX(19px)' : 'translateX(2px)',
                    transition: 'transform 0.2s'
                  }}
                />
              </Switch.Root>
            </span>
          </Popconfirm>
        </span>
      </Tooltip>
    </div>
  );
};

const Sku = () => {
  const searchRef = useRef(null);
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [filters, setFilters] = useState({ search: '', skuStatus: '', fulfillmentType: '', tilesFilter: '', vendorId: null });
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [mapProductModal, setMapProductModal] = useState(false);
  const [uploadFile, setUploadFile] = useState({});
  const [fileUploadingLoading, setFileUploadingLoading] = useState(false);
  const [rowIndex, setRowIndex] = useState(-1);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showMappingAlert, setShowMappingAlert] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [cogsDetailModal, setCogsDetailModal] = useState({ status: false, skuId: null });


  const navigate = useNavigate();

  const {
    skus,
    totalSKUsCount,
    fetchingSKUs,
    unLinkingItem,
    fetchingStats,
    exportingData,
    stats: {
      totalProducts = 0,
      totalNumberOfSkus = 0,
      totalMappedSkus = 0,
      totalUnmappedSkus = 0,
      activeSkus = 0,
      inactiveSkus = 0,
      duplicateAsins = 0
    } = {},
    mappingAlertData,
    mappingAlertErrorMsg,
    checkingWorkOrderLinkStatus,
    skuUnitCostHistories,
    fetchingUnitCostHistories
  } = useSelector((state) => state.threeLayerProducts || {});

  const {
    creatingWorkOrder
  } = useSelector((state) => state.workOrders || {});

  const { currentUser } = useSelector((state) => state.auth || {});

  const { vendorsList, fetchingVendorsList } = useSelector(state => state.pos);

  useEffect(() => {
    dispatch(GetVendorsList());
  }, []);

  const handleExportAll = ()=>{
    dispatch(GetSKUs({exportAll : true})).then(({payload})=>{
      if(payload.success == true){
        handleExportSkus(payload.result);
      }
    });
  };

  const handleExportFiltered = () => {
    const isFilterApplied = Object.entries(filters).some(([key, value]) => {
      if (key === 'tilesFilter') return value !== '';
      if (key === 'vendorId') return value !== null;
      return value !== '';
    });

    if (!isFilterApplied) {
      notification.error({
        top: 65,
        message: 'Export Filtered',
        description: 'Please Select a Filter First'
      });
      return;
    }

    dispatch(ExportFilteredSKUs({ filters, sortBy })).then(({ payload }) => {
      if (payload.success == true) {
        handleExportSkus(payload.result);
      }
    });
  };

  const handleExportSkus = (data)=>{
    
    setOpenExport(false);    
    let sortedSelectedRows;

    if (isArray(data)) {
        sortedSelectedRows = data; 
    } else {
        const selectedRows = selectedItems; 
    
        if (selectedRows.length === 0) {
            notification.error({
                top: 65,
                message: 'Export SKU(s)',
                description: 'Please select at least one row to export.'
            });
            return;
        }
    
        sortedSelectedRows = sort(selectedRows, (item) => indexOf(skus, item));
    }
    

    const mappedData = sortedSelectedRows?.map((skus) => {
      const {
        sku,
        vendorasin,
        item_name,
        status,
        seller_central,
        fulfillment_channel,
        amazon_total,
        amazon_available,
        warehouse_stock,
        price,
        total_value,
        image_url,
        cogs = '-',
        adjusted_sales_velocity = '-',
        is_variety_pack
      } = skus || {};

      return {
        'Title': item_name || 'N/A',
        'SKU': sku || 'N/A',
        'ASIN': vendorasin?.asin || 'N/A',
        'Image Url': image_url || 'N/A',
        'Status': status,
        'Listed': seller_central ? 'True' : 'False',
        'Variety Pack': is_variety_pack ? 'True' : 'False',
        'Cogs': cogs,
        'Adjusted Sales Velocity(90 Days)': adjusted_sales_velocity,
        'Type': fulfillment_channel,
        'Amazon Total': amazon_total || 0,
        'Amazon Available': amazon_available || 0,
        'Warehouse Stock': warehouse_stock || 0,
        'Selling Price': price != null && !isNaN(price) ? Number(price).toFixed(2) : '0.00',
        'Total Value': total_value != null ? `$${total_value}` : '$0'
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'SKUs');

    XLSX.writeFile(workbook, 'Skus.xlsx');
  };
  
  const handleExportSkuMapping = () => {
    setOpenExport(false);
    dispatch(ExportSkuMapping()).then(({ payload }) => {
      if (payload?.success) {
        const mappedData = payload.result?.map((m) => ({
          'SKU': m.sku || 'N/A',
          'ASIN': m.asin || 'N/A',
          'Identifier Type': m.identifier_type || 'N/A',
          'Identifier Value': m.product_upc || 'N/A',
          'Pack Qty': m.pack_qty || 0,
          'Variety Pack': m.variety_pack,
          'Product Name': m.product_name || 'N/A',
          'Brand': m.brand || 'N/A',
          'Listed': m.listed === 'true' ? 'True' : 'False'
        }));

        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'SKU Mapping');
        XLSX.writeFile(workbook, 'Sku_Mapping.xlsx');
      }
    });
  };

  useEffect(() => {
    dispatch(GetStats());
    dispatch(GetSKUs({ page, filters, sortBy }));
  }, []);

  useEffect(() => {
    if (cogsDetailModal.status && cogsDetailModal.skuId) {
      dispatch(GetSkuUnitCostHistories({ skuId: cogsDetailModal.skuId }));
    }
  }, [cogsDetailModal.status, cogsDetailModal.skuId]);

  useEffect(() => {
    if (gridApi && skus?.length > 0) {
      gridApi.forEachNode((node) => {
        if (selectedItems.some(i => i.id === node.data.id)) {
          node.setSelected(true, false, true);
        }
      });
    }
  }, [skus, gridApi]);

  const SelectExportType = ()=>{
    return (
      <InventoryWrapper className='mt-0'>
        <div className='items-menu'>
          <span onClick={() => handleExportSkus()}>Export Selected</span>
          <span onClick={handleExportFiltered}>Export Filtered</span>
          <span onClick={handleExportAll}>Export All</span>
          <span onClick={handleExportSkuMapping}>Export SKU Mapping</span>
        </div>
      </InventoryWrapper>
    );
  };
  const handleExportToggle = (e)=>{
    setOpenExport(!openExport);
    e.stopPropagation();
  };

  const boxData = [
    {
      label: 'Total Products',
      value: totalProducts,
      icon: iconPurple,
      className: 'box-purple',
      key: 'totalProducts'
    },
    {
      label: 'Total No. of SKU',
      value: totalNumberOfSkus,
      icon: iconBlue,
      className: 'box-blue',
      key: 'totalSkus'
    },
    {
      label: 'Total Unmapped SKU',
      value: totalUnmappedSkus,
      icon: iconRed,
      className: 'box-red',
      key: 'totalUnMappedSkus'
    },
    {
      label: 'Total Mapped SKU',
      value: totalMappedSkus,
      icon: iconYellow,
      className: 'box-yellow',
      key: 'totalMappedSkus'
    },
    {
      label: 'Active SKU',
      value: activeSkus,
      icon: iconGreen,
      className: 'box-green',
      key: 'totalActiveSkus'
    },
    {
      label: 'Inactive SKU',
      value: inactiveSkus,
      icon: iconOrange,
      className: 'box-orange',
      key: 'totalInActiveSkus'
    },
    {
      label: 'Duplicate Asins',
      value: duplicateAsins,
      icon: iconBlue,
      className: 'box-blue',
      key: 'totalDuplicateAsins'
    }
  ];

  const handleVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    accept: ['.xlsx', '.xls', '.csv'],
    fileList: !isEmpty(uploadFile) ? [{ ...uploadFile, name: uploadFile.name, key: uploadFile.uid || uploadFile.name }] : [],
    onChange(info) {
      if (info.fileList.length === 0) {
        return;
      }
      const file = info.file;
      const fileExtension = file?.name?.split('.').pop();

      if (!['xls', 'xlsx', 'csv'].includes(fileExtension)) {
        message.error(`${file.name} upload failed. Only Excel or Csv files are allowed.`);
        return;
      }
      setUploadFile(file);
    },
    beforeUpload: () => false,
    onRemove: () => {
      setUploadFile({});
      return true;
    }
  };

  const handleFileUpload = async () => {
    let uploadedFile = {};
    if (!isEmpty(uploadFile)) {
      setFileUploadingLoading(true);
      dispatch(setItem({
        field: 'showFileHeader',
        value: false
      }));
      await dispatch(GetPresignedUrl({ files: [uploadFile] })).then(({ payload }) => {
        if (!payload?.error) {
          uploadedFile = payload[0];
        }
      });
      if (uploadedFile) {
        await dispatch(StoreProductsFile({ fileName: uploadedFile?.key, fileUrl: uploadedFile?.url, fileType: uploadedFile?.extension, type: 'sku' })).then(({ payload }) => {
          if (!payload?.error) {
            message.success('File Uploaded Successfully');
          } else {
            message.error('Error While Uploading File');
          }
          setFileUploadingLoading(false);
          setUploadFile({});
          setPopoverVisible(false);
        });
      }
      await dispatch(GetSKUs({ page, filters, sortBy }));
      dispatch(setItem({
        field: 'showFileHeader',
        value: true
      }));
    }
  };

  const content = (
    <InventoryWrapper style={{ width: 350 }} className='pt-0'>
      <p className="text-primary d-flex align-items-center gap-1">
        <a
          href="https://opulant-storage.s3.us-east-1.amazonaws.com/sku_template_file.xlsx"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary d-flex align-items-center gap-1"
        >
          <img src={InfoIcon} alt="info" />
          <span className="fs-12 fw-semibold">Download Sample File</span>
        </a>      </p>
      <Dragger {...uploadProps} style={{ marginTop: 16, padding: 16, borderRadius: 8 }}>
        <p className="ant-upload-drag-icon">
          <img src={uploadIcon} alt='upload' />
        </p>
        <p className="ant-upload-text text-primary fs-14 fw-semibold text-decoration-underline">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single upload
        </p>
      </Dragger>
      <p className="text-grey d-flex align-items-center gap-1 mt-2">
        <img src={WarningInfoIcon} alt="warning" />
        <span className="fs-12 fw-semibold">Skus with Incomplete data will not be Added</span>
      </p>

      <h6>Uploaded Files</h6>
      {
        !isEmpty(uploadFile) &&
        <div className="uploaded-file-container">
          <div key={uploadFile.uid} className="uploading-content-data">
            <div className="title">
              <img src={FileIcon} alt="File Icon" title="File Icon" />
              <span>{uploadFile.name}</span>
            </div>
            <AiOutlineDelete onClick={() => setUploadFile({})} style={{ cursor: 'pointer', color: 'red' }} />
          </div>
        </div>
      }
      <div className='d-flex gap-2 justify-content-end mt-3'>
        <Button
          text="Cancel"
          className="outlined mb-0"
          onClick={() => {
            setPopoverVisible(false);
            setUploadFile({});
          }
          } />
        <Button
          text={fileUploadingLoading ? 'Uploading..' : 'Save'}
          disabled={fileUploadingLoading || isEmpty(uploadFile)}
          className="primary mb-0"
          onClick={handleFileUpload}
        />
      </div>
    </InventoryWrapper>
  );

  const columnDefs = useMemo(() => [
    {
      headerName: '',
      field: 'products_v2.length',
      cellRenderer: 'agGroupCellRenderer',
      width: 75
    },
    {
      headerName: '',
      headerCheckboxSelection: true,
      width: 35,
      checkboxSelection: true,
      sortable: false
      // field: 'select',
    },
    {
      headerName: 'Product',
      filter: true,
      minWidth: 370,
      flex: 1,
      cellRenderer: ({ data }) => {
        const { image_url, item_name, vendorasin, sku } = data || {};

        return (
          <div className="product-title">
            <img src={image_url || ProductImg} alt="product" width={28} height={28} className='product-img'
              style={{ cursor: 'pointer' }}
              onClick={() => window.open(`${OPEN_PRODUCT_TO_AMAZON_URL}/${vendorasin?.asin}`, '_blank')}
            />
            <div className='w-100'>
              <Tooltip placement="bottom" title={item_name}>
                <span
                  className="product-name"
                  style={{ cursor: 'pointer' }}
                  onClick={() => window.open(`${OPEN_PRODUCT_TO_AMAZON_URL}/${vendorasin?.asin}`, '_blank')}
                >
                  {item_name}
                </span>
              </Tooltip>
              <div className='d-flex align-items-center gap-2'>
                <div className='asin'>
                  <span className='tw-max-w-[68px] tw-text-truncate'><span>{vendorasin?.asin}</span></span>
                  <img src={copyIcon} alt='copy' className='cursor-pointer cursor-pointer'
                    onClick={() => copyToClip(vendorasin?.asin)}
                  />
                </div>
                <div className='asin sku'>
                  <span className='tw-max-w-[160px] tw-text-truncate'><span>{sku}</span></span>
                  <img src={copyIcon} alt='copy' className='cursor-pointer'
                    onClick={() => copyToClip(sku)}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }
    },
    {
      headerName: 'Status',
      field: 'status',
      minWidth: 120,
      flex: 1,
      cellRenderer: ({ value }) => {
        return value || 'Active';
      }
    },
    {
      headerName: 'Listed',
      field: 'seller_central',    // important for sorting
      sortable: true,             // enables API call on sort
      minWidth: 130,
      flex: 1,
      cellRenderer: ({ value }) => (value === 1 ? 'True' : 'False')
    },
    {
      headerName: 'Variety Pack',
      field: 'is_variety_pack',
      comparator: () => 0,
      sortable: true,
      minWidth: 130,
      flex: 1,
      cellRenderer: ({ data }) => {
        return <VarietyPackSwitch data={data} />;
      }
    },
    {
      headerName: 'COGS',
      field: 'cogs',
      sortable: true,
      comparator: () => 0,
      minWidth: 120,
      flex: 1,
      cellRenderer: CogsCellRenderer
    },
    {
      headerName: 'ASV (90D)',
      field: 'adjusted_sales_velocity',
      comparator: () => 0,
      sortable: true,
      minWidth: 200,
      flex: 1,
      cellRenderer: ({ value, data }) => {
        let displayValue;
        if (value == null || value === '' || value === 0 || value === '0.00') {
          displayValue = '-';
        } else {
          const num = Number(value);
          displayValue = Number.isInteger(num) ? num.toString() : num.toFixed(2);
        }
        
        const tooltipContent = (
          <div style={{ maxWidth: '720px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
            <div>Total Ordered Units (90 Days): {Math.floor(data?.ordered_units ?? 0)}</div>
            <div>In Stock Days (90 Days): {data?.in_stock_days ?? 0}</div>
            <div>Adjusted Sales Velocity (90 Days): {displayValue === '-' ? 0 : displayValue}</div>
          </div>
        );
        
        return (
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {displayValue}
            <Tooltip
              title={tooltipContent}
              placement="top"
              overlayStyle={{ width: 'max-content', maxWidth: '760px' }}
              overlayInnerStyle={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
            >
              <img src={InfoIcon} alt="info" style={{ width: '14px', height: '14px', cursor: 'pointer' }} />
            </Tooltip>
          </span>
        );
      }
    },
    {
      headerName: 'Type',
      minWidth: 120,
      flex: 1,
      field: 'fulfillment_channel',
      cellRenderer: ({ value }) => {
        return (
          (value === 'FBA') ? 'FBA' : 'FBM'
        );
      }
    },
    {
      headerName: 'AMZ Total',
      minWidth: 130,
      flex: 1,
      sortable: true,
      comparator: () => 0,
      field: 'amazon_total',
      cellRenderer: ({ value }) => value || 0
    },
    {
      headerName: 'AMZ Available',
      minWidth: 130,
      flex: 1,
      sortable: true,
      comparator: () => 0,
      field: 'amazon_available',
      cellRenderer: ({ value }) => value || 0
    },
    {
      headerName: 'WH Stock',
      minWidth: 130,
      flex: 1,
      comparator: () => 0,
      sortable: true,
      field: 'warehouse_stock',
      cellRenderer: ({ value }) => value || 0
    },
    {
      headerName: 'Selling Price',
      minWidth: 130,
      flex: 1,
      comparator: () => 0,
      sortable: true,
      field: 'price',
      cellRenderer: ({ value }) => {
        if (!value || isNaN(value)) return '0.00';
        return `$${Number(value).toFixed(2)}`;
      }
    },
    {
      headerName: 'Total Value',
      minWidth: 130,
      flex: 1,
      comparator: () => 0,
      sortable: true,
      field: 'total_value',
      cellRenderer: ({ value }) => value ? `$${value}` : '$0'
    },
    {
      headerName: 'Action',
      minWidth: 125,
      flex: 1,
      cellRenderer: ({ node, data }) => {
            const isMapProductAllowed = data?.is_variety_pack ? true : data?.products_v2?.length === 0 ? true : false;
            return (
              <Button disabled={!isMapProductAllowed} className="primary mb-0" text="MAP Product" onClick={() => {
                dispatch(CheckWorkOrderLinkStatus({
                  id: data?.id,
                  idType: 'sku'
                }))
                  .then(({ payload }) => {
                    if (payload?.success) {
                      setRowIndex(node.rowIndex);
                      setMapProductModal(true);
                    }
                    else setShowMappingAlert(true);
                  });
              }} />
            );
      }
    }
  ]);

  const gridOptions = useMemo(() => ({
    context: {
      openCogsModal: (skuId) => setCogsDetailModal({ status: true, skuId })
    }
  }), []);

  const cogsDetailColumnDefs = useMemo(() => [
    {
      headerName: 'PO Name',
      field: 'po_name',
      minWidth: 200,
      flex: 1,
      cellRenderer: ({ value }) => value || 'N/A'
    },
    {
      headerName: 'Received',
      field: 'received_quantity',
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ value }) => value ?? 0
    },
    {
      headerName: 'Adjustment',
      field: 'adj_received_quantity',
      minWidth: 120,
      flex: 1,
      cellRenderer: ({ value }) => {
        const num = Number(value || 0);
        if (num === 0) return '0';
        return num > 0 ? `+${num}` : `${num}`;
      }
    },
    {
      headerName: 'Used',
      field: 'used_quantity',
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ value }) => value ?? 0
    },
    {
      headerName: 'Available',
      field: 'inbound_stock',
      minWidth: 150,
      flex: 1,
      cellRenderer: ({ value }) => value ?? 0
    },
    {
      headerName: 'Unit Cost',
      field: 'unit_cost',
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ value }) => `$${Number(value).toFixed(2)}`
    }
  ], []);

  const handleSearchProduct = debounce((value) => {
    setFilters((prev) => {
      if (trim(value) || prev.search) {
        setPage(page => ({ ...page, pageNumber: 1 }));
        dispatch(GetSKUs({
          page: { ...page, pageNumber: 1 },
          filters: { ...prev, search: trim(value), tilesFilter: '' },
          sortBy
        }));
      }
      return { ...prev, search: value, tilesFilter: '' };
    });
  }, 800);

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(GetSKUs({
      page: newPage,
      filters,
      sortBy
    }));
  };

  const refreshGridClick = () => {
    if (gridColumnApi){
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true
      });
      setSortBy({ key: '', type: '' });
    }

    dispatch(GetSKUs({
      page,
      filters
    }));
  };

  const handleFulfillmentType = (e) => {
    setFilters(filters => ({ ...filters, fulfillmentType: e?.value, tilesFilter: '' }));
    setPage(page => ({ ...page, pageNumber: 1 }));
    dispatch(GetSKUs({
      page: { ...page, pageNumber: 1 },
      filters: { ...filters, fulfillmentType: e?.value, tilesFilter: '' },
      sortBy
    }));
  };

  const handleSkuStatus = (e) => {
    setFilters(filters => ({ ...filters, skuStatus: e?.value, tilesFilter: '' }));
    setPage(page => ({ ...page, pageNumber: 1 }));
    dispatch(GetSKUs({
      page: { ...page, pageNumber: 1 },
      filters: { ...filters, skuStatus: e?.value, tilesFilter: '' },
      sortBy
    }));
  };

  const handleTilesFilter = (key) => {
    const tilesFilter = filters.tilesFilter === key ? '' : key;
    searchRef.current.value = '';
    setFilters({ tilesFilter });
    setPage(page => ({ ...page, pageNumber: 1 }));
    dispatch(GetSKUs({
      page: { ...page, pageNumber: 1 },
      filters: { tilesFilter },
      sortBy
    }));
  };

  const handleRefreshPageData = (sku_id) => {
    dispatch(GetStats());
    setPage(page => ({ ...page, pageNumber: 1 }));
    setSortBy({ key: '', type: '' });
    setFilters(prev => {
      const newFilters = { search: '', skuStatus: '', fulfillmentType: '', tilesFilter: '', vendorId: prev.vendorId };
      searchRef.current.value = '';
      dispatch(GetSKUs({
        page: { ...page, pageNumber: 1 },
        filters: newFilters,
        sortBy: { key: '', type: '' }
      })).then(() => {
        sku_id ? expandRow(sku_id) : '';
      });
      return newFilters;
    });
  };

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null);

     if (value && ['price', 'amazon_total', 'amazon_available', 'warehouse_stock', 'reserved_qty', 'total_value', 'cogs', 'is_variety_pack', 'seller_central', 'adjusted_sales_velocity'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(GetSKUs({
        page,
        filters,
        sortBy: { key: colId, type: sort }
      }));
    }
  };

  const gridReady = (params) => {
    gridApi = params.api;
    gridColumnApi = params.columnApi;
  };

  const expandRow = (rowId) => {
    if (gridApi) {
      gridApi.forEachNode((node) => {
        if (node.data.id === rowId) {
          node.setExpanded(true);
        }
      });
    }
  };

  const handleCreateWorkOrder = () => {
    const selectedRows = selectedItems;

    if (selectedRows.length === 0) {
      notification.error({
        top: 65,
        message: 'Create Work Order',
        description: 'Please select at least one row to create.'
      });
      return;
    }

    const hasZeroStock = selectedRows?.some(item => !Number(item.warehouse_stock));
    if (hasZeroStock) {
      notification.error({
        top: 65,
        message: 'Create Work Order',
        description: 'Ensure warehouse stock is available before adding the SKU'
      });
      return;
    }

    const orderItems = selectedRows?.map(({ id: sku_id }) => ({ sku_id })) || [];

    dispatch(CreateWorkOrder({
      orderItems
    })).then(({ payload }) => {
      const { success, workOrderId } = payload || {};
      if (success) navigate(`/inventory/work-order/${workOrderId}`);
    });
  };

  const onSelectionChange = () => {
    const currentPageSelected = gridApi?.getSelectedRows?.() || [];
    const currentPageAll = skus || [];
    const currentPageAllIds = currentPageAll.map(i => i.id);

    setSelectedItems(prev => {
      const otherPagesSelected = prev.filter(i => !currentPageAllIds.includes(i.id));
      const newSelected = [...otherPagesSelected, ...currentPageSelected];
      setSelectedRowsCount(newSelected.length);
      return newSelected;
    });
  };

  const { pageNumber, pageSize } = page || {};

  const handleShowMappingAlert = () => {
    setMapProductModal(false);
    setShowMappingAlert(true);
  };

  return (
    <InventoryWrapper>
      <div gutter={24} className='box-row'>
        {boxData.map((data, ind) => (
          <div className={`sku-box ${filters.tilesFilter === data.key ? 'active-box' : ''} ${data.className}`}
            onClick={() => handleTilesFilter(data.key)}
            key={ind}
          >
            <p>{data.label}</p>
            <h4 className='fw-bold mb-0'>{data.value}</h4>
          </div>
        ))}
      </div>
      <div className='sku-bar'>
        <SearchInput
          placeholder="Search by ASIN / Title / SKU"
          width="264px"
          inputRef={searchRef}
          onChange={({ target }) => handleSearchProduct(target.value)}
        />
        <div className='sku-inputs'>
          <Select
            isClearable={true}
            placeholder="Select Vendor"
            className="mb-0"
            disabled={fetchingVendorsList}
            width="200px"
            value={filters.vendorId ? vendorsList.find(v => v.id === filters.vendorId) : ''}
            options={vendorsList}
            onChange={(option) => {
              const newVendorId = option?.id || null;
              setFilters(prev => {
                const newFilters = { ...prev, vendorId: newVendorId };
                setPage(page => ({ ...page, pageNumber: 1 }));
                dispatch(GetSKUs({
                  page: { ...page, pageNumber: 1 },
                  filters: { ...newFilters, search: trim(searchRef.current?.value || '') },
                  sortBy
                }));
                return newFilters;
              });
            }}
          />
          <Select
            isClearable={true}
            placeholder="Fulfillment Type"
            className="mb-0"
            width="135px"
            value={filters?.fulfillmentType ? { label: filters?.fulfillmentType } : ''}
            options={FULFILLMENT_TYPES}
            onChange={handleFulfillmentType}
          />
          <Select
            isClearable={true}
            placeholder="Sku Status"
            className="mb-0"
            width="125px"
            value={filters?.skuStatus ? { label: filters?.skuStatus } : ''}
            options={SKU_STATUSES}
            onChange={handleSkuStatus}
          />
           <Popover visible={openExport} overlayStyle={{ padding: 0 }} overlayClassName='dropdown-pop' trigger='click' Arrow={false} placement='bottom' title={null} content={<SelectExportType />}>
          <Spin size='small' spinning={exportingData}>
          <Button
          disabled={!skus?.length || exportingData}
           onClick={handleExportToggle} startIcon={<GoUpload style={{marginRight:'16px'}}/>} endIcon={<IoIosArrowDown />} className="outlined mb-0" text="Export" />
           </Spin>
          </Popover>
          {/* <Button
            text="Add SKU"
            className="outlined mb-0"
            startIcon={<span className="icon-add pr-8"></span>}
            minWidth="96px"
            onClick={() => setShowModal(true)}
          /> */}
          <Popover
            content={content}
            trigger="click"
            placement="bottomRight"
            visible={popoverVisible}
            onVisibleChange={handleVisibleChange}
          >
            <Button
              text="Bulk Map SKUs"
              className="primary mb-0"
              startIcon={<IoCloudUploadOutline />}
              minWidth="90px"
            />
          </Popover>
          <Button
            text={`Create Work Order (${selectedRowsCount})`}
            className="primary mb-0"
            startIcon={<span className="icon-add pr-8"></span>}
            minWidth="90px"
            onClick={handleCreateWorkOrder}
            disabled={creatingWorkOrder || !currentUser?.is_active || (currentUser.is_employee_of && !currentUser.permissions.includes(3))}
          />
        </div>
      </div>
      <Spin tip='Loading...' spinning={fetchingSKUs || unLinkingItem || creatingWorkOrder || checkingWorkOrderLinkStatus}>
        <AgGrid
          gridReady={gridReady}
          user_referrals={skus}
          defaultColDef={defaultColDef}
          columnDefinitions={columnDefs}
          rowHeight={52}
          headerHeight={34}
          height="268px"
          rowSelection="multiple"
          masterDetail={true}
          detailRowAutoHeight={true}
          onSortChange={onSortChange}
          onSelectionChanged={onSelectionChange}
          gridOptions={gridOptions}
          detailCellRenderer={(props) => <SkuRowDetails
            {...props}
            handleRefreshPageData={handleRefreshPageData}
            expandRow={expandRow}
            setShowMappingAlert={setShowMappingAlert}
          />}
          className="sku-table"
        />
      </Spin>
      <Pagination
        total={totalSKUsCount}
        totalPages={ceil(totalSKUsCount / pageSize + 1)}
        pageNumber={pageNumber}
        pageLimit={pageSize}
        handleLimitChange={(e) => handlePagination(e, 'pageSize')}
        handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
        refreshGridClick={refreshGridClick}
        isExport={true}
      />
      {showMappingAlert &&
        <MappingAlert
          rowData={mappingAlertData}
          errorMessage={mappingAlertErrorMsg}
          showMappingAlert={showMappingAlert}
          setShowMappingAlert={setShowMappingAlert}
        />
      }
      {showModal && <AddSkuModal open={showModal} onHide={() => setShowModal(false)} onSave={handleRefreshPageData} />}
      {mapProductModal && <MapProductModal
        open={mapProductModal}
        onHide={() => setMapProductModal(false)}
        rowIndex={rowIndex}
        onSave={handleRefreshPageData}
        handleShowMappingAlert={handleShowMappingAlert}
      />}

      <Modal
        open={cogsDetailModal.status}
        onHide={() => setCogsDetailModal({ status: false, skuId: null })}
        closeText="Close"
        header={true}
        closeButton={true}
        onClose={() => setCogsDetailModal({ status: false, skuId: null })}
        saveButton={false}
        className="cogs-modal-full-width cogs-modal-scroll"
        centerAlign={false}
        size="xl"
      >
        <InventoryWrapper className='sku-modal modal-grid cogs-modal-content p-0'>
          <div className='cogs-modal-header'>
            <div className='cogs-modal-header-icon'>
              <img src={InfoIcon} alt='info' width={18} height={18} />
            </div>
            <div>
              <h4 className='mb-0'>COGS Breakdown Detail</h4>
              <p className='cogs-modal-subtitle mb-0'>Weighted average cost breakdown by purchase order</p>
            </div>
          </div>
          <Spin tip='Loading...' spinning={fetchingUnitCostHistories}>
            {skuUnitCostHistories?.map((product, pIndex) => {
              const historyCount = product.histories?.length || 0;
              const gridHeight = historyCount === 0 ? '120px' : historyCount <= 3 ? `${(historyCount * 40) + 34 + 20}px` : null;
              
              // Calculate component COGS for this product
              let totalValue = 0;
              let totalAvailable = 0;
              product.histories?.forEach(h => {
                const avail = Number(h.inbound_stock || 0);
                const cost = Number(h.unit_cost || 0);
                if (avail > 0) {
                  totalValue += (avail * cost);
                  totalAvailable += avail;
                }
              });
              const componentCogs = totalAvailable > 0 ? (totalValue / totalAvailable) : 0;
              const subtotal = componentCogs * product.bundleQty;
              
              return (
                <div key={pIndex} className="cogs-product-section">
                  <div className="cogs-product-header">
                    <div className='d-flex align-items-center gap-2'>
                      <span className='cogs-product-index'>{pIndex + 1}</span>
                      <span className='cogs-product-name'>{product.productName}</span>
                    </div>
                    <span className='cogs-bundle-badge'>Bundle Qty: {product.bundleQty}</span>
                  </div>
                  <AgGrid
                    user_referrals={product.histories || []}
                    columnDefinitions={cogsDetailColumnDefs}
                    defaultColDef={defaultColDef}
                    {...(gridHeight ? { containerHeight: gridHeight } : { height: '300px' })}
                    rowHeight={40}
                    className="cogs-detail-grid"
                  />
                  
                  {historyCount > 0 && totalAvailable > 0 && (
                    <div className='cogs-summary-card mt-3'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <div>
                          <div className='cogs-summary-label'>Component COGS</div>
                          <div className='cogs-summary-sublabel'>Weighted avg across {totalAvailable} available units</div>
                        </div>
                        <div className='cogs-summary-value'>${componentCogs.toFixed(2)}</div>
                      </div>
                      <div className='cogs-summary-divider'></div>
                      <div className='d-flex align-items-center justify-content-between'>
                        <div>
                          <div className='cogs-summary-label'>Subtotal for SKU</div>
                          <div className='cogs-summary-sublabel'>${componentCogs.toFixed(2)} × {product.bundleQty} bundle qty</div>
                        </div>
                        <div className='cogs-summary-value'>${subtotal.toFixed(2)}</div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            
            {skuUnitCostHistories?.length > 1 && (
              <div className='cogs-summary-card cogs-total-card mt-2'>
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='cogs-summary-label' style={{ fontSize: '14px' }}>Total SKU COGS</div>
                  <div className='cogs-summary-value' style={{ fontSize: '22px' }}>
                    ${skuUnitCostHistories.reduce((acc, p) => {
                      let tv = 0, ta = 0;
                      p.histories?.forEach(h => {
                        const avail = Number(h.inbound_stock || 0);
                        if (avail > 0) {
                          tv += (avail * Number(h.unit_cost || 0));
                          ta += avail;
                        }
                      });
                      return acc + (ta > 0 ? (tv / ta) : 0) * p.bundleQty;
                    }, 0).toFixed(2)}
                  </div>
                </div>
              </div>
            )}
          </Spin>
        </InventoryWrapper>
      </Modal>
    </InventoryWrapper >
  );
};

export default Sku;
